import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { countTires, formatTireDimension, TIRE_SET_INTRO_SAMPLE } from "../consts";
import { TireSetSceneProps } from "../types";

/** Korak "Gume": kartica seta s gumom, dubina profila po gumi i praćenje seta. */
const TireSetTiresScene: React.FC<TireSetSceneProps> = ({ formValues }) => {
  const firstTire = formValues.tires[0];
  const manufacturer = firstTire?.tireManufacturer?.name || TIRE_SET_INTRO_SAMPLE.manufacturer;
  const dimension = formatTireDimension(firstTire) || TIRE_SET_INTRO_SAMPLE.dimension;
  const type = firstTire?.tireType?.name || TIRE_SET_INTRO_SAMPLE.type;
  const quantity = countTires(formValues.tires) || TIRE_SET_INTRO_SAMPLE.quantity;

  // Dubina profila po gumi; dok nije upisana, primjer.
  const depths = formValues.tires.some((tire) => tire.profileDepth)
    ? formValues.tires.flatMap((tire) => Array.from({ length: tire.quantity ?? 1 }, () => tire.profileDepth ?? 0)).slice(0, 4)
    : TIRE_SET_INTRO_SAMPLE.profileDepths;
  const dot = firstTire?.dot ?? TIRE_SET_INTRO_SAMPLE.dot;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          {/* Slika ima bijelu podlogu kao kartica, pa bez okvira; uvećana da guma ispuni vrh kartice. */}
          <div className="h-[9rem] overflow-hidden">
            <img src={TIRE_SET_INTRO_SAMPLE.image} alt="" className="w-full h-full object-contain scale-[1.35]" />
          </div>

          <div className="mt-3 flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">
                {formValues.code || TIRE_SET_INTRO_SAMPLE.code}
              </div>
              <div className="text-sm font-bold text-slate-800 truncate">
                {manufacturer} {dimension}
              </div>
            </div>
            <span className="px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-sky-100 text-sky-700 flex-shrink-0">
              {type}
            </span>
          </div>
          <div className="mt-2 text-[0.65rem] text-slate-400">{quantity} kom · DOT {dot}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dubina profila</div>
          <div className="mt-3 flex items-end justify-between gap-2 h-16">
            {depths.map((depth, index) => (
              <div key={index} className="flex flex-1 flex-col items-center gap-1">
                <div className="w-full rounded-sm bg-emerald-400" style={{ height: `${Math.min(depth / 8, 1) * 3.5}rem` }} />
                <span className="text-[0.55rem] font-semibold text-slate-500">{depth} mm</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Set se prati kroz sustav"
          subtitle="Pozicija i stanje guma na jednom mjestu"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <circle cx="12" cy="12" r="4" />
              <path d="M12 3v5M12 16v5M3 12h5M16 12h5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(TireSetTiresScene);
